import { useEffect, useState } from "react";
import PostList from "../components/PostList/PostList";
import SideMenu from "../components/SideMenu/SideMenu";
import { useSearchParams } from "react-router-dom";

import { Helmet } from "react-helmet-async";

const PostListPage = () => {
  const [open, setOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const category = searchParams.get("category");

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <div className="p-8">
      <Helmet>
        <title>GSPEN – ყველა სტატია</title>
        <meta
          name="description"
          content="იხილეთ ყველა GSPEN სტატია ერთ ადგილზე – კვება, კალორიები, დიეტები და ჯანმრთელობა."
        />
        <link rel="canonical" href="https://www.gspen.ge/blog/posts" />
      </Helmet>
      <h1 className="mb-4 text-2xl">
        {category ? category : "ყველა კატეგორია"}
      </h1>
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="bg-blue-800 text-sm text-white px-4 py-2 mx-4 rounded-2xl my-0 mx-0 md:hidden"
      >
        {open ? "დახურვა" : "გაფილტვრა/ძებნა"}
      </button>
      <div className="flex flex-col-reverse gap-8 md:flex-row justify-between">
        <div className="w-full">
          <PostList />
        </div>
        <div className={`${open ? "block" : "hidden"} md:block`}>
          <SideMenu />
        </div>
      </div>
    </div>
  );
};

export default PostListPage;
